import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { ElForm, ElFormItem, ElInput } from 'element-plus'
import { ref, defineProps, onMounted, defineEmits, computed, reactive } from 'vue'
import { FlowFormModel } from '../types'
const __default__ = {
  name: 'SnakerFlowStart'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

// 注意:ref不能与model一样，相同的话表单双向绑定将会失效
const formRef = ref(null)
// const form = reactive<FlowFormModel>({} as FlowFormModel)
const form = computed<FlowFormModel>({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', Object.assign(props.modelValue, val))
})
// 定义属性
const props = __props
const emits = __emit
// watch(() => form, (n, o) => {
//   emits('update:modelValue', Object.assign(props.modelValue, form))
// }, { deep: true })

// 表单规则校验配置
const formRules: any = reactive<any>({
  name: [{ required: true, message: '名称必填' }]
})

onMounted(() => {
  Object.assign(form, props.modelValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ElForm), {
      ref_key: "formRef",
      ref: formRef,
      model: form.value,
      "label-width": "120px",
      size: "default",
      rules: formRules
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElFormItem), {
          label: "名称",
          required: "",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "前置拦截器" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.preInterceptors,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.preInterceptors) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "后置拦截器" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.postInterceptors,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.postInterceptors) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})